import type { Template } from "@/types";

export const PO_05_H2_V3: Template[] = [
    {
        id: "po-05-h2v3-01",
        name: "PO 01 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 77, y: 156, width: 233, height: 321, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 156, width: 233, height: 321, rotation: 0, imageRotation: 0 },
            { id: "3", x: 77, y: 483, width: 233, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 317, y: 483, width: 233, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 705, y: 69, width: 467, height: 646, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-02",
        name: "PO 02 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 30, y: 0, width: 566, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 693, y: 489, width: 243, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 943, y: 489, width: 242, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 693, y: 139, width: 243, height: 344, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 139, width: 242, height: 344, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-03",
        name: "PO 03 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_03.png",
        size: [1252, 783],
        style: {},
        slots: [          
            { id: "1", x: 30, y: 0, width: 566, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 693, y: 300, width: 243, height: 344, rotation: 0, imageRotation: 0 },         
            { id: "3", x: 693, y: 139, width: 243, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 139, width: 243, height: 344, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 489, width: 243, height: 155, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h2v3-04",
        name: "PO 04 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 79, y: 68, width: 467, height: 646, rotation: 0, imageRotation: 0 },
            { id: "2", x: 678, y: 148, width: 498, height: 312, rotation: 0, imageRotation: 0 },
            { id: "3", x: 678, y: 467, width: 119, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1058, y: 467, width: 118, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 805, y: 467, width: 246, height: 169, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-05",
        name: "PO 05 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 84, y: 149, width: 453, height: 286, rotation: 0, imageRotation: 0 },
            { id: "2", x: 84, y: 442, width: 300, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 391, y: 442, width: 146, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 669, y: 204, width: 267, height: 374, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 204, width: 266, height: 374, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-06",
        name: "PO 06 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 57, y: 217, width: 252, height: 349, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 217, width: 252, height: 349, rotation: 0, imageRotation: 0 },
            { id: "3", x: 943, y: 217, width: 262, height: 349, rotation: 0, imageRotation: 0 },
            { id: "4", x: 674, y: 217, width: 262, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 674, y: 395, width: 262, height: 171, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-07",
        name: "PO 07 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 145, width: 783, height: 492, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 145, width: 463, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 790, y: 439, width: 149, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 947, y: 439, width: 149, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1103, y: 439, width: 149, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-08",
        name: "PO 08 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 145, width: 783, height: 492, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 145, width: 463, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 790, y: 439, width: 149, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 947, y: 439, width: 149, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1103, y: 439, width: 149, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-09",
        name: "PO 09 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 37, y: 189, width: 289, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 334, y: 189, width: 289, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 334, y: 395, width: 289, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 189, width: 289, height: 404, rotation: 0, imageRotation: 0 },
            { id: "5", x: 926, y: 189, width: 289, height: 404, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-10",
        name: "PO 10 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 176, width: 308, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 315, y: 176, width: 307, height: 431, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 176, width: 307, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 395, width: 307, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 944, y: 176, width: 307, height: 431, rotation: 0, imageRotation: 0 }
        ],
    }
];